<template>
  <transition name="fade">
    <div
      v-if="show"
      :class="['bubble-dialog', {
        'mobile': mobile
      }]"
    >
      <p class="bubble-dialog__title">{{ getQuest.point !== 4 ? 'Менеджер' : 'Оператор' }}</p>
      <div class="bubble-dialog__content">
        {{ getQuest.text }}
      </div>
      <div class="bubble-dialog__buttons">
        <button
          type="button"
          class="btn btn--small bubble-dialog__buttons-item click-sound"
          v-if="getQuest.point !== 4"
          @click="continueQuest"
        >
          {{ getQuest.button_text }}
        </button>
        <div
          v-else>
          <button
            class="btn btn--small bubble-dialog__buttons-item bubble-dialog__buttons-item--full click-sound"
            @click="$emit('continueQuest', getQuest.action, getQuest.point)"
          >
            Нет, я еще посмотрю направления
          </button>
          <button
            class="btn btn--small bubble-dialog__buttons-item bubble-dialog__buttons-item--full click-sound"
            @click="$emit('continueQuest', true, getQuest.point)"
          >
            Да, хочу узнать
          </button>
       </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { detect } from 'detect-browser'
  import { Quest } from '@/data'

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      currentPoint: {
        type: Number,
        default: 1
      }
    },
    data(){
      return {
        osInfo: ''
      }
    },
    created(){
      const deviceInfo = detect();
      this.osInfo = deviceInfo.os;
    },
    computed: {
      getQuest(){
        return Quest.find(quest => quest.point === this.currentPoint);
      },
      mobile(){
        return this.osInfo === 'Android OS' || this.osInfo === 'iOS' ? true : false;
      }
    },
    methods: {
      continueQuest(){
        if(this.getQuest.button_href != undefined && this.getQuest.button_href != '#'){
          window.open(this.getQuest.button_href, '_blank');
        }

        this.$emit('continueQuest', this.getQuest.action, this.getQuest.point);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bubble-dialog {
    position: absolute;
    width: 355px;
    color: #FFF;
    background: #273743;
    user-select: text;
    z-index: 1000;

    text-align: center;
    padding-bottom: 10px;

    &:after {
      content: "";
      position: absolute;
      top: 100%;
      right: 39px;
      margin-top: -1px;

      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 0 solid transparent;
      border-top: 30px solid #273743;
    }
    &.mobile {
      width: 410px;
      padding-bottom: 15px;
    }
    &__title {
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
      background-color: rgba(0,7,22, .39);
      user-select: none;
    }
    &__content {
      padding: 15px;
      font-size: 18px;
      user-select: none;
    }
    &.mobile &__content {
      font-size: 21px;
    }
    &__buttons {
      padding: 0 15px;

      &-item {
        padding: 7px 15px;
        margin-bottom: 10px;
        font-size: 16px;

        &--full {
          width: 100%;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    &.mobile &__buttons {

      &-item {
        font-size: 21px;
      }
    }
  }
</style>
